import type { Category } from '~/types/shopware'
import { getShopPermalink, getCategoryPermalinkByForeignKey } from '~/lib/'
import { useSeoUrlStore } from '~/store/seoUrlStore'
import { Link } from '~/types'

export const useShopBreadcrumbs = (category: Category) => {
  const { t } = useI18n()
  const localePath = useLocalePath()
  const seoStore = useSeoUrlStore()

  const finalBreadcrumbs = category.breadcrumb.slice(1)
  const currentCategory = finalBreadcrumbs.pop() ?? ''
  const finalPaths = category.path?.split('|').filter(Boolean).slice(1) || []

  // Warm the SEO URL cache asynchronously
  useAsyncData(`breadcrumbs-seo-urls-${category.id}`, async () => {
    if (finalPaths.length) await seoStore.ensureCategoryUrls(finalPaths)
    return true
  })

  const breadcrumbs = computed<Link[]>(() => {
    const parents = finalBreadcrumbs.map((breadcrumb, index) => {
      const id = finalPaths[index]
      const seoUrl = id ? seoStore.getCategoryUrlById(id) : ''
      const url = seoUrl ? localePath(seoUrl) : id ? localePath(getCategoryPermalinkByForeignKey(id)) : ''
      return { text: breadcrumb, url }
    })
    return [
      { text: t('shop.breadcrumbs.home'), url: '/' },
      { text: t('shop.breadcrumbs.shop'), url: localePath(getShopPermalink()) },
      ...parents,
      { text: currentCategory, url: '' },
    ]
  })

  return { breadcrumbs }
}
